'use client';

import { FooterIcon } from '@/icons/FooterIcon';
import { BottomMenu } from '@/models/BottomMenu';
import { SettingsHomepageItem } from '@/models/Settings';
import Image from 'next/image';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { useState } from 'react';
import { CheckoutPage } from '@/lib/checkoutRoutes';
import SmartImage from './SmartImage';

export default function AppFooterContent({
  bottomMenu,
  mainCategories,
}: {
  bottomMenu: BottomMenu[];
  mainCategories: SettingsHomepageItem[];
}) {
  const pathname = usePathname();

  const [onlySimple, setOnlySimple] = useState<boolean>(false);

  // useEffect(() => {
  //   if (pathname === '/hediye-202506') {
  //     setOnlySimple(true);
  //     return;
  //   }
  //   const campaignName = getCampaignName();
  //   if (campaignName === 'hediye-202506') {
  //     setOnlySimple(true);
  //     return;
  //   }
  // }, [pathname]);

  if (
    Object.values(CheckoutPage)
      .map((item) => `/${item}`)
      .includes(pathname)
  ) {
    return <></>;
  }

  return (
    <>
      <footer className="bg-hzc_purple_500 px-8 py-8 text-hzc_purple_200 text-sm font-medium">
        <div className="container mx-auto items-center justify-center flex-row mb-12 gap-10 hidden md:flex">
          <Image
            src="https://cdn.hizlicicek.com/public/app_store/hizlicicek_uygulama_indir.png"
            alt="Uygulamayı İndir"
            width={100}
            height={100}
            className="max-w-xs w-[100px] h-[100px] object-contain rounded-sm"
            unoptimized={true}
          />
          <div className="text-xl font-semibold tracking-tight text-slate-50">
            Hızlı Çiçek deneyimi artık cebinde!
            <span className="block italic text-sm text-emerald-300 mt-1">
              Uygulamayı indirmek için QR kodu okutman yeterli.
            </span>
            <div className="mx-auto items-center justify-center flex-row gap-10 hidden md:flex">
              <Image
                src="https://cdn.hizlicicek.com/public/app_store/android_hizli_cicek_indir.png"
                alt="Google Play Store"
                width={135}
                height={40}
                className="max-w-xs mt-6 w-[135px] h-[40px] object-contain"
                unoptimized={true}
              />
              <Image
                src="https://cdn.hizlicicek.com/public/app_store/apple_hizli_cicek_indir.png"
                alt="Apple App Store"
                width={135}
                height={40}
                className="max-w-xs mt-6 w-[135px] h-[40px] object-contain"
                unoptimized={true}
              />
            </div>
          </div>
        </div>
        <div className="container mx-auto items-center justify-center flex-col md:mb-12 mb-4 gap-1 flex md:hidden">
          <div className="text-l font-semibold tracking-tight text-slate-50 text-center">
            Hızlı Çiçek deneyimi artık cebinde!
          </div>
          <Link
            href="https://play.google.com/store/apps/details?id=com.hizlicicek.android"
            target="_blank"
            rel="noopener noreferrer"
            className="block"
          >
            <Image
              src="https://cdn.hizlicicek.com/public/app_store/android_hizli_cicek_indir.png"
              alt="Google Play Store"
              width={135}
              height={40}
              className="max-w-xs mt-2 md:mt-6 w-[135px] h-[40px] object-contain"
              unoptimized={true}
            />
          </Link>
          <Link
            href="https://apps.apple.com/ca/app/h%C4%B1zl%C4%B1-%C3%A7i%C3%A7ek-%C3%A7i%C3%A7ek-g%C3%B6nder/id6752895233"
            target="_blank"
            rel="noopener noreferrer"
            className="block"
          >
            <Image
              src="https://cdn.hizlicicek.com/public/app_store/apple_hizli_cicek_indir.png"
              alt="Apple App Store"
              width={135}
              height={40}
              className="max-w-xs mt-2 md:mt-6 w-[135px] h-[40px] object-contain"
              unoptimized={true}
            />
          </Link>
        </div>
        <div className="container mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-8 justify-items-center">
          {!onlySimple &&
            mainCategories.map((category) => (
              <div key={category.title} className="flex flex-col items-center gap-4 row-span-4">
                <span className="text-hzc_green text-center w-full font-medium text-base">
                  {category.title}
                </span>
                {category.categories?.map((item, innerIndex) => {
                  return (
                    <Link
                      key={innerIndex}
                      href={item.url || ''}
                      prefetch={false}
                      className="flex items-center gap-2 text-center hover:underline"
                      aria-label={item.title}
                    >
                      <span className="text-sm">{item.title}</span>
                    </Link>
                  );
                })}
              </div>
            ))}
          {bottomMenu.map((bottomMenu, index) => (
            <div key={index} className="flex flex-col items-center gap-4 row-span-1">
              <span className="text-hzc_green text-center w-full font-medium text-base">
                {bottomMenu.groupTitle}
              </span>
              {bottomMenu.items.map((item, innerIndex) => {
                const href = item.url?.includes('mailto:') ? item.url.replace('/', '') : item.url;

                if (item.title === 'Çerez Tercihlerini Yönetin') {
                  return (
                    <a
                      key={innerIndex}
                      href="#"
                      className="efl-edit flex items-center gap-2 text-center hover:underline"
                      aria-label={item.title}
                    >
                      <span className="text-sm">{item.title}</span>
                    </a>
                  );
                }

                if (!href || href === '') {
                  return (
                    <div
                      key={innerIndex}
                      className="flex items-center gap-2 text-center"
                      aria-label={item.title}
                    >
                      {item.icon && (
                        <SmartImage
                          width={18}
                          height={18}
                          src={item.icon || ''}
                          alt={`${item.title} ikonu`} //alty
                          quality={80}
                          style={{
                            objectFit: 'contain',
                            height: '18px',
                          }}
                          imageType="icon"
                        />
                      )}
                      <span className="text-sm">{item.title}</span>
                    </div>
                  );
                }

                return (
                  <Link
                    key={innerIndex}
                    href={href || ''}
                    prefetch={false}
                    target={!item.url?.includes('hizlicicek.com/') ? '_blank' : '_self'}
                    className="flex items-center gap-2 text-center hover:underline"
                    aria-label={item.title}
                  >
                    {item.icon && (
                      <SmartImage
                        width={18}
                        height={18}
                        src={item.icon || ''}
                        alt={`${item.title} ikonu`} //alty
                        quality={80}
                        style={{
                          objectFit: 'contain',
                          height: '18px',
                        }}
                        imageType="icon"
                      />
                    )}
                    <span className="text-sm">{item.title}</span>
                  </Link>
                );
              })}
            </div>
          ))}
        </div>
        <div className="flex justify-center mt-16">
          <FooterIcon className="h-[160px]" />
        </div>
      </footer>
      <footer className="flex justify-between py-4 px-8 items-center">
        <SmartImage
          src="https://cdn.hizlicicek.com/public/etbis.png"
          alt="hızlı çiçek etbis'e kayıtlıdır"
          imageType="sub-banner"
          quality={85}
          loading="lazy"
          sizes="60px"
          className="md:w-[60px] md:h-[60px] w-[40px] h-[40px]"
          unoptimized={true}
        />
        <SmartImage
          className="lg:hidden w-[229px]"
          width={229}
          height={60}
          src="/agreements.png"
          alt="hızlı çiçek güvenli ödeme"
          style={{ width: 'auto' }}
          imageType="custom"
        />
        <SmartImage
          className="hidden lg:flex w-[300px]"
          width={300}
          height={46}
          src="/agreements.png"
          alt="hızlı çiçek güvenli ödeme"
          style={{ width: 'auto' }}
          imageType="custom"
        />
      </footer>
    </>
  );
}
